import type { ThemeConfig } from "antd";

/** App-level overrides on top of craftOS-ui shared theme (light-only app). */
export const appThemeOverrides: ThemeConfig = {};
